package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_01_10_Day_1
import com.veldekar.components.logs.Log_2026_01_10_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-01-10")
@Composable
public fun Log_2026_01_10(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Destiny, Danger… and a Down Payment",
        ogTitle = "Destiny, Danger… and a Down Payment",
        date = LocalDate(2_026, 1, 10),
        ogDescription = "The heroes face their own thoughts, shady justice, and a bastion priced like it’s cursed.",
        ogImage = "images/freeburgBastion_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of the Friends of the Forest's Freeburg Bastion with its yellow tower and surrounding wall.",
    ) {
        SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
        Log_2026_01_10_Day_1()
        SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
        Log_2026_01_10_Day_2()
        SessionMediaItem(
            image = "images/freeburgBastion.webp",
            linkImage = "images/freeburgBastion.webp",
            description = "A hand-drawn illustration of the Friends of the Forest's Freeburg Bastion with its yellow tower and surrounding wall.",
            width = 3_671,
            height = 2_860,
        )
    }
}
